(function () {
  function initMapGallery() {
    document.querySelectorAll('[data-map-gallery]').forEach(function (track) {
      if (track.dataset.loopReady) return;
      track.dataset.loopReady = 'true';
      var carousel = track.closest('.custom-map-style-page__gallery-carousel');
      var originals = Array.from(track.querySelectorAll('.custom-map-style-page__gallery-item'));
      if (originals.length < 2) return;

      function cloneItem(item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      var before = originals.map(cloneItem);
      var after = originals.map(cloneItem);
      before.slice().reverse().forEach(function (item) { track.prepend(item); });
      after.forEach(function (item) { track.append(item); });

      var groupWidth = 0;
      var normalizing = false;
      function measure() {
        groupWidth = after[0].offsetLeft - originals[0].offsetLeft;
      }
      function jumpTo(left) {
        normalizing = true;
        var previousScrollBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        window.requestAnimationFrame(function () {
          track.style.scrollBehavior = previousScrollBehavior;
          normalizing = false;
        });
      }
      measure();
      jumpTo(groupWidth);

      function normalize() {
        if (normalizing || !groupWidth) return;
        if (track.scrollLeft < groupWidth - 1) jumpTo(track.scrollLeft + groupWidth);
        else if (track.scrollLeft >= groupWidth * 2 - 1) jumpTo(track.scrollLeft - groupWidth);
      }

      function move(direction) {
        if (!groupWidth) return;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        var step = originals[0].getBoundingClientRect().width + gap;
        track.scrollTo({
          left: track.scrollLeft + direction * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      carousel.querySelectorAll('[data-map-gallery-scroll]').forEach(function (button) {
        button.addEventListener('click', function () {
          move(button.getAttribute('data-map-gallery-scroll') === 'next' ? 1 : -1);
        });
      });
      track.tabIndex = 0;
      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });

      // Native swiping enters an identical cloned set, then resets invisibly.
      var scrollTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(normalize, 140);
      }, { passive: true });
      if ('onscrollend' in track) track.addEventListener('scrollend', normalize);

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          var oldGroupWidth = groupWidth;
          var relativePosition = oldGroupWidth ? ((track.scrollLeft % oldGroupWidth) + oldGroupWidth) % oldGroupWidth / oldGroupWidth : 0;
          measure();
          jumpTo(groupWidth + relativePosition * groupWidth);
        }, 100);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMapGallery);
  else initMapGallery();
  document.addEventListener('shopify:section:load', initMapGallery);
}());
